import * as yup from 'yup';

yup.setLocale({
	mixed: {
		required: 'error.required', // Translation key goes here
		notType: 'error.required',
	},
	string: {
		required: 'error.required',
		email: 'error.correctEmail',
	},
	number: {
		required: 'error.required',
	},
	boolean: {
		isValue: 'error.required',
	},
});

export const createJobSchema = yup.object().shape({
	description: yup.string().required(),

	deadline: yup.date().required(),

	assignedToId: yup.string().required(),
});
